import { render, staticRenderFns } from "./SelectReference.vue?vue&type=template&id=470b3b2d"
import script from "./SelectReference.vue?vue&type=script&lang=js"
export * from "./SelectReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports